<div class="col-md-12" id="header">
  <h5>Import d'un BC
    <mat-icon class="close-button" (click)="onModalCancel()" color="primary" *ngIf="!submitted || received">cancel
    </mat-icon>
  </h5>
  <mat-divider></mat-divider>
</div>
<form class="row display-element" [formGroup]="bcImportform" (ngSubmit)="onSubmit()" *ngIf="!submitted">
  <div class="col-sm-12">
    <div style="float: left;">
      <app-file-upload formControlName="file"></app-file-upload>
      <mat-error *ngIf="fileControl.hasError('validatorFileSize')">
        Fichier trop volumineux ! 2mo maximum
      </mat-error>
      <mat-error *ngIf="fileControl.hasError('validatorFileType')">
        Format du fichier incorrect ! Veuillez choisir un fichier CSV
      </mat-error>
    </div>
  </div>
  <div class="col-sm-12">
    <!-- [disabled]="!bcImportform.valid"-->
    <button mat-raised-button color="primary" type="submit">
      <mat-icon>publish</mat-icon> Importer
    </button>
  </div>
</form>
<mat-spinner class="mat-spinner" mode="indeterminate" *ngIf="submitted && !received"></mat-spinner>
<div *ngIf="received">
  <div id="nbBc">
    <b>Nombre de BC: </b> {{result.nbBc}}
  </div>
  <div id="totalHt">
    <b>Total HT: </b> {{result.totalHt.toLocaleString(undefined, {minimumFractionDigits: 2, style: "currency", currency: "EUR"}) }}
  </div>
</div>